var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "876px",
    height: "876px",
    viewBox: "0 0 876 876",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CheckMid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CheckMid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(83.000000, 345.000000)",
    fill: "#1A3482"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0241896,3.9801692 C32.50509,-7.81067911 4.50531212,7.48231223 0.483971928,38.1373175 C-3.53736826,68.7923227 17.9436895,103.201553 48.4627892,114.991401 C78.9828862,126.781249 106.694428,111.683321 111.295232,81.2583914 C116.35482,47.8134756 93.5442866,15.7700172 63.0241896,3.9801692",
    id: "Fill-46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMid);
export default __webpack_public_path__ + "static/media/CheckMid.caeb3bc4b70008bed9b0cbe7c468768c.svg";
export { ForwardRef as ReactComponent };